export const NAME_TO_CODE: Record<string, string> = {
  "United States": "US",
  "United Kingdom": "GB",
  China: "CN",
  Taiwan: "TW",
  Japan: "JP",
  "South Korea": "KR",
  "Hong Kong": "HK",
  Singapore: "SG",
  Switzerland: "CH",
  "Saudi Arabia": "SA",
  "United Arab Emirates": "AE",
  Qatar: "QA",
  Kuwait: "KW",
  Israel: "IL",
  India: "IN",
  Australia: "AU",
  "New Zealand": "NZ",
  Canada: "CA",
  Mexico: "MX",
  Brazil: "BR",
  Argentina: "AR",
  Chile: "CL",
  Colombia: "CO",
  Germany: "DE",
  France: "FR",
  Netherlands: "NL",
  Belgium: "BE",
  Austria: "AT",
  Spain: "ES",
  Italy: "IT",
  Portugal: "PT",
  Ireland: "IE",
  Sweden: "SE",
  Norway: "NO",
  Finland: "FI",
  Denmark: "DK",
  "Czech Republic": "CZ",
  Poland: "PL",
  Greece: "GR",
  Turkey: "TR",
  Russia: "RU",
  Ukraine: "UA",
  "South Africa": "ZA",
  Indonesia: "ID",
  Thailand: "TH",
  Malaysia: "MY",
  Vietnam: "VN",
  Philippines: "PH",
  Bermuda: "BM",
  Luxembourg: "LU",
  "Cayman Islands": "KY",
  Kazakhstan: "KZ",
  Peru: "PE",
  Slovenia: "SI",
  Morocco: "MA",
  Cyprus: "CY",
  Lebanon: "LB",
  Guernsey: "GG",
  Kenya: "KE",
  Jordan: "JO",
  Jersey: "JE",
  Hungary: "HU",
};

export function countryNameToCode(name?: string | null): string | null {
  if (!name) return null;
  const trimmed = name.trim();
  return NAME_TO_CODE[trimmed] || null;
}
